module.exports = __webpack_public_path__ + "1f0bfc0865d324c2587920a7d80c609b.png";